import { FC } from 'react';

type Props = {
  name: string;
  emodji: string;
  onClick: () => void;
};

export const ChatBotSuggestion: FC<Props> = ({ name, emodji, onClick }) => {
  return (
    <div className="flex h-10 overflow-hidden relative rounded-lg group cursor-pointer bg-gray-200 hover:bg-gradient-orange-to-purple hover:shadow-sm hover:p-0.5 p-0.375">
      <button
        type="button"
        className="rounded-md group-hover:bg-base-white bg-gray-50 flex flex-nowrap items-center gap-x-2.25 text-md text-gray-700 font-medium group-hover:p-2.5 p-2.625 group-hover:text-gray-900"
        onClick={onClick}
      >
        <span className="text-[20px]/[20px]">{emodji}</span>
        {name}
      </button>
    </div>
  );
};
